<template>
  <div class="page_content" v-if="permission && permission.version === '5'">

    <div class="row page-heading mx-0">
        <div class="col-8 input module_heading" role="heading" aria-level="1">
            <span class="module_icon icon-ic_ToC"></span>
            <span class="module_type_name">Competency Tree Management</span>
        </div>
        <div class="col-4 submit btn-container text-right">
            <button type="button" class="btn btn-primary" @click.prevent="uploadCompetency" aria-label="upload" :disabled="permission.systemPermission.readOnly">upload</button>
        </div>
    </div>

    <div class="competency-list-section folder-management-section" v-if="isDataSetupFromServer">
        <div class="page_subheading">
          <div class="toolbar-right ui-list-toolbar">
            <select v-model="perPage" aria-label="page size" class="page_size">
              <option v-for="option in pageOptions" v-bind:value="option">
                {{ option }}
              </option>
            </select>
            <div class="btn_container pagination_sty3">
              <b-pagination
                align="center"
                :total-rows="totalRows"
                :per-page="perPage"
                v-model="currentPage"
                :limit="1"
                :hide-goto-end-buttons="true"
                :label-prev="$t('previousPage')"
                :label-next="$t('nextPage')">
                <template #prev-text>
                  <span class="ic2_arr_pre3" aria-hidden="true"></span>
                </template>
                <template #next-text>
                  <span class="ic2_arr_next3" aria-hidden="true"></span>
                </template>
              </b-pagination>
            </div>
            <div class="search-box-container">
              <input type="text" class="input-search" v-model="filter" placeholder="search by title" aria-label="search by title">
              <button type="button" class="btn btn_srh" aria-label="search competency trees">
                <span class="ic_srh ic_search" aria-hidden="true"></span>
              </button>
            </div>
          </div>
        </div>

        <b-container fluid>
            <b-row class="competency-list-table">
                <b-table bordered :isRowHeader="true" :head-variant="'light'" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" @filtered="onFiltered">
                    <template slot="title" slot-scope="row">
                        {{row.value}}
                    </template>
                    <template slot="actions" slot-scope="row">
                        <template v-if="permission.systemPermission.readOnly">
                            <!--<span class="action-link icon-pencil mr-2" @click="editCompetency(row.item)" aria-label="edit" tabindex="0" style="pointer-events: none; color: #ccc;"></span>-->
                            <span class="action-link icon-bin" @click="showDeleteCompetencyConfirmBox(row.item)" aria-label="delete" tabindex="0" style="pointer-events: none; color: #ccc;"></span>
                        </template>
                        <template v-else>
                            <!--<span class="action-link icon-pencil mr-2" @click="editCompetency(row.item)" aria-label="edit" tabindex="0" style="pointer-events: none; color: #ccc;"></span>-->
                            <span class="action-link icon-bin" @click="showDeleteCompetencyConfirmBox(row.item)" aria-label="delete" tabindex="0"></span>
                        </template>
                    </template>
                </b-table>

                <template v-if="(shouldShowNoResultFound || (items.length === 0))">
                    <span class="no-result">No Results Found</span>
                </template>
            </b-row>

        </b-container>
    </div>

    <div>
        <b-modal class="delete-competency-popup" ref="deleteCompetencyModal" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>
            <div>
                <span>{{ competencyDeleteMessage }}</span>
            </div>
          <div slot="modal-header" class="popover-header">
            <div class="popup-heading">Please Confirm!</div>
            <button class="btn_close" aria-label="close" @click="hideDeleteConfirmBox">
                <span class="ic-close"></span>
            </button>
          </div>
          <div slot="modal-footer" class="w-100">
              <b-button @click="deleteCompetencyAndHideDeleteConfirmBox" class="btn button-primary float-right mr-2" aria-label="yes"> yes </b-button>
              <b-button @click="hideDeleteConfirmBox" class="btn button-primary float-right mr-2" aria-label="no"> no </b-button>
          </div>
        </b-modal>
    </div>

    <div class="loading-spinner">
        <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
            <div class="text-center" style="color: #FFF">
                <i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
            </div>
        </b-modal>
    </div>

  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import _ from 'lodash'
  import '../../../assets/module/css/competencyManagement/competencyTreeList.min.css'

  export default {
    name: 'competencyTreeList',
    data () {
      return {
        items: [],
        fields: [
          {key: 'displayTitleForTeacher', label: 'Competency Title', class: 'first-column'},
          {key: 'actions', label: 'Actions', class: 'second-column text-center'}
        ],
        totalRows: 0,
        competencyToDelete: '',
        competencyDeleteMessage: '',
        isDataSetupFromServer: false,
        currentPage: 1,
        perPage: 10,
        pageOptions: [ 10, 50, 100 ],
        filter: '',
        shouldShowNoResultFound: false
      }
    },

    mounted () {
      this.loadPermission().then(res => {
        this.$refs.loadingModal.show()
        setTimeout(() => {
          this.loadCompetencies()
        }, 1000)
      })
    },

    methods: {
      ...mapActions([
        'deleteCompetencies',
        'loadPLOForInstitution',
        'loadPermission'
      ]),

      loadCompetencies () {
        this.loadPLOForInstitution().then(res => {
          this.items = _.orderBy(res, ['lastUpdatedTime'], ['desc'])
          this.totalRows = this.items.length
          this.isDataSetupFromServer = true
          this.$refs.loadingModal.hide()
        })
      },

      uploadCompetency () {
        return this.$router.push({name: 'competencyTreeUpload'})
      },

      editCompetency (competency) {
        console.log('competency tree updation is not implemented')
      },

      showDeleteCompetencyConfirmBox (competency) {
        this.competencyToDelete = competency
        this.competencyDeleteMessage = 'Are you sure you want delete "' + competency.displayTitleForTeacher + '" competency tree.'
        this.$refs.deleteCompetencyModal.show()
      },

      hideDeleteConfirmBox () {
        this.$refs.deleteCompetencyModal.hide()
      },

      deleteCompetencyAndHideDeleteConfirmBox () {
        this.hideDeleteConfirmBox()
        this.$refs.loadingModal.show()
        let uuids = [this.competencyToDelete.uuid]
        this.deleteCompetencies(uuids).then(res => {
          setTimeout(() => {
            this.loadCompetencies()
            this.$notify({
              group: 'notify',
              type: 'success',
              title: '',
              text: 'Competency tree "' + this.competencyToDelete.displayTitleForTeacher + '" deleted successfully.'
            })
          }, 1000)
        })
      },

      onFiltered (filteredItems) {
        this.totalRows = filteredItems.length
        this.currentPage = 1
        if (filteredItems.length === 0) {
          this.shouldShowNoResultFound = true
        } else {
          this.shouldShowNoResultFound = false
        }
      }
    },
    computed: {
      ...mapState({
        'permission': state => state.user.permission
      })
    }
  }
</script>

<style scoped>
    .action-link {
        cursor: pointer;
    }

    .no-result {
        text-align: center;
        width: 100%;
        padding: 5px 0;
        margin-top: -80px;
    }
</style>



// WEBPACK FOOTER //
// src/app/course/components/CompetencyTreeList.vue